import { apiRequestDev } from './apiRequest';

export const getAllFeedback = async (config) => apiRequestDev(config, '/feedback/all');

export const getMessageInfo = async (config, id) => apiRequestDev(config, `/feedback/info/${id}`);

export const getRidingInfo = async (config, userId) => apiRequestDev(config, `/ridings/user?id=${userId}`);

export const getPollInfo = async (config, postalCode) => apiRequestDev(config, `/polls/postal/${postalCode}`);

export const getRidingData = async (config, ridingId) => apiRequestDev(config, `/ridings/data/${ridingId}`);
